import { render, staticRenderFns } from "./FormBuilder.vue?vue&type=template&id=04b7cb4c&scoped=true"
import script from "./FormBuilder.vue?vue&type=script&lang=ts"
export * from "./FormBuilder.vue?vue&type=script&lang=ts"
import style0 from "./FormBuilder.vue?vue&type=style&index=0&id=04b7cb4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b7cb4c",
  null
  
)

export default component.exports